module.exports = __webpack_public_path__ + "static/img/患者在线购药闭环@2x.ca531551.png";